/** @format */

import axios from 'axios';
import { message } from 'antd';

import { store } from '../store';
import ACTIONS_TYPE from '../reducers/actionType';
import overallConfig from '../config/index';

axios.defaults.withCredentials = true; // 允许携带cookie

const axiosInstance = axios.create({
  baseURL: overallConfig.ideamanServiceUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    const librec_paper_token = window.localStorage.getItem(
      'librec_paper_token',
    );
    if (librec_paper_token) {
      config.headers.Authorization = `${librec_paper_token}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => {
    // authorization 属性是小写
    if (response.headers.authorization) {
      const token = response.headers.authorization;
      window.localStorage.setItem('librec_paper_token', token);
    }

    return response.data;
  },
  error => {
    if (error.toString().endsWith('403')) {
      const librec_paper_token = window.localStorage.getItem(
        'librec_paper_token',
      );
      if (librec_paper_token) {
        message.error('Login status expired, please sign in again');
        console.dir(store);
        store.dispatch({ type: ACTIONS_TYPE.LOGOUT });
        window.localStorage.removeItem('librec_paper_token');
      }
    }

    return Promise.reject(error);
  },
);

export { axiosInstance as axios };
